import {ModuleNode} from '@backstage-components/base';
import {Alert, AlertIcon} from '@chakra-ui/react';
import {FC} from 'react';
import {SchemaType} from './SlideshowDefinition';

export type SlideshowProps = SchemaType;

export const SlideshowPreviewComponent: FC<
  ModuleNode<'Slideshow', SlideshowProps>
> = () => {
  return (
    <Alert status="info">
      <AlertIcon />
      The SlideShow will only appear in your site preview. Slideshow will scale
      to fill it's container.
    </Alert>
  );
};
